<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item><div style="display: inline-block;" @click="gotopage('/Basics/brand.html')">系统设置</div></el-breadcrumb-item>
			<el-breadcrumb-item>行业模板</el-breadcrumb-item>
		</el-breadcrumb>

		<el-form :inline="true" :model="item" class="search">
			<el-form-item label="所属行业">
				<el-select v-model="item.industry_id" clearable placeholder="请选择" size="small">
					<el-option v-for="item in options" :key="item.index" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="模板名称">
				<el-input v-model="item.name" placeholder="请输入模板名称" size="small"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submit" size="medium">查询</el-button>
			</el-form-item>
		</el-form>
		<div class="btns">
			<el-button type="primary" size="small" @click="add" v-auth="['admin/industry.template/add']">添加行业模板</el-button>
			<el-button type="danger" size="small" @click="delAll" v-auth="['admin/industry.template/delete']">批量删除</el-button>
		</div>

		<el-table :data="list" border @selection-change="handleSelectionChange">
			<el-table-column type="selection" align="center"></el-table-column>
			<el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column>

			<el-table-column prop="name" label="模板名称"></el-table-column>
			<el-table-column  label="所属行业" align="center">
				<template slot-scope="scope">
					<div style="display: flex; align-items: center;" v-if="scope.row.industry">
						{{scope.row.industry.name}}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="160">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" @click="edit(scope.row.id)" v-auth="['admin/industry.template/update']">编辑</el-button>
					<el-popconfirm title="您确定要删除这条数据吗？" @confirm="del(scope.row.id)" class="l10" v-auth="['admin/industry.template/delete']">
						<el-button size="mini" type="danger" slot="reference">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page"
			:current-page.sync="pageNum" :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
</template>
<script>
	export default {
		name: 'index',
		data() {
			return {
				list: [],
				isLoad: false,
				pageNum: 0,
				pageSize: 20,
				total: 0,
				page: 1,
				// 查询
				item: {},
				value: '',
				number: 0,
				options: []
			}
		},
		created() {
			this.item = {
					page: this.page,
					limit: this.pageSize
				},
				this.loadList()
		},
		methods: {
			gotopage(url){
				var link =  this.$router.resolve({
					path: url,
				});
				window.open(link.href, '_blank')
			},
			async loadList() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				let res = ""

				res = await this.axios.post('/admin/data/listIndustryForSelect', {
				})
				this.options = res.data.list

				res = await this.axios.post('/admin/industry.template/list', this.item)
				// 获取数据
				this.list = res.data.list.data
				// 页数 page
				this.total = res.data.list.total

				this.isLoad = !this.isLoad
			},
			// 跳转到edit添加
			add() {
				this.$router.push({
					path: '/TradeTemplate/edit.html'
				});
			},
			// 传一个ID跳转到edit页面，进行编辑
			edit(id) {
				this.$router.push({
					path: '/TradeTemplate/edit.html',
					query: {
						id: id
					}
				});
			},
			//
			del(id) {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.axios.delete('/admin/industry.template/delete', {
						data: {
							ids: id
						}
					})
					.then(() => {
						this.isLoad = !this.isLoad
						this.$message.success({
							message: '删除成功',
							showClose: false
						});
						this.loadList()
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			delAll() {
				let id = []
				for (let key in this.multipleSelection) {
					let item = this.multipleSelection[key]
					id.push(item.id)
				}
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.delete('/admin/industry.template/delete', {
						data: {
							ids: id
						}
					}).then(() => {
						this.isLoad = !this.isLoad
						this.$message.success({
							message: '删除成功',
							showClose: false
						});
						this.loadList()
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},
			sizeReload(val) {
				this.item.pageSize = val
				this.loadList()
			},
			pageReload(val) {
				this.item.page = val
				this.loadList()
			},
			// 搜索查询
			submit() {
				this.pageNum = 1
				this.item.page = 1
				this.loadList()
			},
			// 导出
			excelOut() {
				return;
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.get('/Member/excelOut', {
						params: {
							nickname: this.item.nickname,
							title: this.item.title
						}
					})
					.then(res => {
						this.isLoad = !this.isLoad
						// 导出
						window.open(res.url)
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			}
		}
	}
</script>
<style scoped>
</style>
